import { ModalBase } from "./ModalBase";

function NotificationModal({
    title,
    subtitle,
    showModal,
    onCancelPress,
    onGetStartedPress
}: Readonly<{
    title: string,
    subtitle: string,
    showModal: boolean,
    onCancelPress: () => void,
    onGetStartedPress: () => void,
}>) {

    return (
        <ModalBase
            open={showModal}
            type={'info'}
            title={title}
            subtitle={subtitle}
            leftBtnTxt={"Cancel"}
            onLeftBtnPress={onCancelPress}
            rightBtnTxt={"Get Started"}
            onRightBtnPress={onGetStartedPress}
        />
    )
}


export default NotificationModal
